<template>
    <div>
        <b-row>
            <b-col cols="12">
                <b-card class="mb-3" title="Katılım Formları">
                    <b-form>
                        <b-row>
                            <b-col cols="12">
                                <table class="table b-table table-responsive">
                                    <thead>
                                        <th>#</th>
                                        <th>İçerik</th>
                                        <th>Ad Soyad</th>
                                        <th>E-Posta</th>
                                        <th>D.Tarihi</th>
                                        <th>Telefon</th>
                                        <th>İşletme</th>
                                        <th>Tarih</th>
                                    </thead>
                                    <tr v-for="form in forms" :key="form.id">
                                        <td>{{ form.id }}</td>
                                        <td>{{ form.content.title }}</td>
                                        <td>{{ form.name }} {{ form.surname }}</td>
                                        <td>{{ form.email }}</td>
                                        <td>{{ form.birthday }}</td>
                                        <td>{{ form.phone }}</td>
                                        <td>{{ form.company }}</td>
                                        <td>{{ form.createdAt }}</td>
                                    </tr>
                                    <thead>
                                        <th>#</th>
                                        <th>İçerik</th>
                                        <th>Ad Soyad</th>
                                        <th>E-Posta</th>
                                        <th>D.Tarihi</th>
                                        <th>Telefon</th>
                                        <th>İşletme</th>
                                        <th>Tarih</th>
                                    </thead>
                                </table>
                            </b-col>
                        </b-row>
                    </b-form>
                    <b-button class="float-left mt-2" v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-primary"
                    @click="exportData()">Dışa Aktar </b-button>
                </b-card>
            </b-col>
        </b-row>

    </div>
</template>
<script>
import Ripple from "vue-ripple-directive";
import {
    BRow,
    BCol,
    BImg,
    BCard,
    BForm,
    BBadge,
    BAlert,
    BButton,
    BAvatar,
    BCardText,
    BButtonGroup,
    BListGroupItem,
    BButtonToolbar,
} from "bootstrap-vue";

import settings from '../../../settings';
import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();
export default {
    components: {
        BRow,
        BCol,
        BImg,
        BCard,
        BForm,
        BBadge,
        BAlert,
        BButton,
        BAvatar,
        BCardText,
        BButtonGroup,
        BListGroupItem,
        BButtonToolbar,
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            forms: []
        };
    },
    watch: {},
    methods: {
        exportData() {
            window.open(`${settings.apiBaseUrl}/api/v1/dashboard/export/forms/participants?hl=${this.$i18n.locale}`, '_blank');
        },
        getFormParticipants() {
            endpoints
                .getFormParticipants(null, this.$i18n.locale, () => { })
                .then((data) => {
                    this.forms = [...data.response];
                    console.log(this.forms)
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
    mounted() {
        this.getFormParticipants();
    },
};
</script>
 
